/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramCategoryControllerGetMetaTreeShallowQueryResponse } from '../../types/TelegramCategoryControllerGetMetaTreeShallow.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramCategoryGetMetaTreeShallow } from '../../methods/telegramCategoryGetMetaTreeShallow.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramCategoryGetMetaTreeShallowQueryKey = () =>
  [{ url: '/api/telegram/category/meta-tree/shallow' }] as const;

export type TelegramCategoryGetMetaTreeShallowQueryKey = ReturnType<typeof telegramCategoryGetMetaTreeShallowQueryKey>;

export function telegramCategoryGetMetaTreeShallowQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramCategoryGetMetaTreeShallowQueryKey();
  return queryOptions<
    TelegramCategoryControllerGetMetaTreeShallowQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramCategoryControllerGetMetaTreeShallowQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramCategoryGetMetaTreeShallow(config);
    },
  });
}

/**
 * {@link /api/telegram/category/meta-tree/shallow}
 */
export function useTelegramCategoryGetMetaTreeShallow<
  TData = TelegramCategoryControllerGetMetaTreeShallowQueryResponse,
  TQueryData = TelegramCategoryControllerGetMetaTreeShallowQueryResponse,
  TQueryKey extends QueryKey = TelegramCategoryGetMetaTreeShallowQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramCategoryControllerGetMetaTreeShallowQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramCategoryGetMetaTreeShallowQueryKey();

  const query = useQuery(
    {
      ...telegramCategoryGetMetaTreeShallowQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
